export class StudentPayrollRequest implements IPaymentMethodSelectModel{
    onlineEnrollmentId: number;
    paymentOptionId?: number;
    debitCardAckFlag?: boolean
    bankName?: string;
    accountType?: string;
    accountNumber?: string;
    routingNumber?: string;
}

interface IPaymentMethodSelectModel{
    paymentOptionId?: number;
    debitCardAckFlag?: boolean;
    bankName?: string;
    accountType?: string;
    accountNumber?: string;
    routingNumber?: string;
}


// WEBPACK FOOTER //
// ./src/app/shared/models/payment-method-select.model.ts